import { render, staticRenderFns } from "./ProductBatchListView.vue?vue&type=template&id=b55c37dc&scoped=true&"
import script from "./ProductBatchListView.vue?vue&type=script&lang=js&"
export * from "./ProductBatchListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55c37dc",
  null
  
)

export default component.exports